import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';
import './SettingsNav.scss';

export default (options = {}) => {
  let { NavItems, NavItem } = options;
  const { makeMenuId = id => `menu-${id}` } = options;

  if (!NavItem) {
    const Item = ({ page, location, forceIcon, selectedPage }) => {
      const { label, icon: Icon, id, path } = page;
      const errors = page.errors && Object.keys(page.errors).filter(k => page.errors[k]);

      return (
        <li
          id={makeMenuId(id)}
          to={path}
          className={classnames(
            'grb-settings-nav-item',
            ((selectedPage === page) || (location.pathname === path))
              && 'grb-settings-nav-item-selected',
            `grb-settings-nav-item-${page.type || 'default'}`,
          )}
        >
          <Link to={path}>
            {(Icon || forceIcon) && (
              <div className="grb-settings-nav-item-icon">
                {Icon && <Icon />}
              </div>
            )}
            <Typography variant="body2" className="grb-settings-nav-item-text">
              {label}
            </Typography>
            <div className="grb-settings-nav-item-badge">
              {errors && !!errors.length && (
                <Typography className="grb-settings-nav-item-errors">
                  {errors.length}
                </Typography>
              )}
            </div>
          </Link>
          {/* {(expanded === true) && (
            <ExpandLess />
          )}
          {(expanded === false) && (
            <ExpandMore />
          )} */}
        </li>
      );
    };

    Item.propTypes = {
      page: PropTypes.shape({
        label: PropTypes.string,
        id: PropTypes.string,
        path: PropTypes.string,
        icon: PropTypes.oneOfType([
          PropTypes.func,
          PropTypes.shape({}),
        ]),
        errors: PropTypes.shape(),
        type: PropTypes.string,
      }).isRequired,
      selectedPage: PropTypes.shape({}),
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }).isRequired,
      forceIcon: PropTypes.bool,
    };

    Item.defaultProps = {
      forceIcon: false,
      selectedPage: undefined,
    };
    NavItem = Item;
  }

  const TreeNavItem = ({ page, location, forceIcon, level, selectedPage, ...rest }) => {
    // const [open, setOpen] = useState(true);

    // const handleClick = () => {
    //   setOpen(!open);
    // };

    const children = page.children && page.children.filter(p => p.navig) || [];
    return (
      <React.Fragment>
        <NavItem
          page={page}
          location={location}
          forceIcon={forceIcon}
          level={level}
          selectedPage={selectedPage}
          expanded
        />
        {(children.length > 0) && (
          <Collapse in timeout="auto" unmountOnExit>
            <div className={classnames(
                'grb-settings-nav-item-children',
                !forceIcon && 'grb-settings-nav-items-indent',
                page.type && `grb-settings-nav-item-children-${page.type}`,
              )}
            >
              <NavItems
                {...rest}
                pages={children}
                forceIcon={forceIcon}
                location={location}
                level={level + 1}
                selectedPage={selectedPage}
              />
            </div>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  TreeNavItem.propTypes = {
    page: PropTypes.shape({
      id: PropTypes.string,
      path: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({})),
      type: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    selectedPage: PropTypes.shape({}),
    forceIcon: PropTypes.bool,
    level: PropTypes.number.isRequired,
  };

  TreeNavItem.defaultProps = {
    forceIcon: false,
    selectedPage: undefined,
  };

  if (!NavItems) {
    const Items = ({ pages, forceIcon, location, level, selectedPage }) => {
      const hasIcon = forceIcon || !!pages.find(p => p.icon);
      const fpages = pages.filter(p => p.navig);
      return fpages.length ? (
        <ul component="nav" aria-label="settings nav folders" className="grb-settings-nav-items">
          {fpages.map((p) => {
            return p.children ? (
              <TreeNavItem
                key={p.id}
                page={p}
                location={location}
                forceIcon={!!hasIcon}
                level={level}
                selectedPage={selectedPage}
              />
            ) : (
              <NavItem
                key={p.id}
                page={p}
                location={location}
                forceIcon={!!hasIcon}
                level={level}
                selectedPage={selectedPage}
              />
            );
          })}
        </ul>
      ) : (null);
    };

    Items.propTypes = {
      pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }).isRequired,
      forceIcon: PropTypes.bool,
      level: PropTypes.number,
      selectedPage: PropTypes.shape({}),
    };

    Items.defaultProps = {
      forceIcon: false,
      level: 0,
      selectedPage: undefined,
    };
    NavItems = Items;
  }

  const SettingsNav = (props) => {
    return (
      <div className="grb-settings-nav">
        <NavItems {...props} />
      </div>
    );
  };

  SettingsNav.propTypes = {
    pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    selectedPage: PropTypes.shape({}),
  };

  SettingsNav.defaultProps = {
    selectedPage: undefined,
  };
  return SettingsNav;
};
